const user = JSON.parse(localStorage.getItem("user"));
const initialUser = user || null;
const initialLoggedIn = user ? true : false;
const organizadorActivo = Number(localStorage.getItem("or_ac")) || null;

export default () => ({
	// Logica del auth
	loggedIn: initialLoggedIn,
	user: initialUser,

	// Logica del modal
	//loggedInUser: false,
	authModal: {
		visibility: false,
		callbackAction: {
			name: null,
			payload: null,
		},
	},

	// Organizadores
	organizadorActivo: organizadorActivo
});
